import { delay } from 'lodash';

import { LOGIN, LOGIN_SUCCESS } from './authentication.ationTypes';
import { authenticate } from 'api/login';
import setToken from './setToken';

const executeLogin = data => ({ type: LOGIN, payload: data });

const login = (data, resolveParent) => dispatch => {
  dispatch(executeLogin(data));

  delay(() => {
    authenticate(data)
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: response.body,
          });

          dispatch(setToken(response.body.access_token));

          resolveParent({});
        } else if (response.status === 401 || response.status === 400) {
          resolveParent(response.body.errors);
        }
      })
      .catch(() => {
        resolveParent({ req: 'failed' });
      });
  }, 1000);
};

export default login;
